var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.72 147.884C114.434 147.884 147.44 114.879 147.44 74.1643C147.44 33.4499 114.434 0.444336 73.72 0.444336C33.0056 0.444336 0 33.4499 0 74.1643C0 114.879 33.0056 147.884 73.72 147.884Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0648 97.1859C43.2491 97.919 47.8484 115.12 73.72 115.12C99.5957 115.12 104.191 97.919 104.375 97.1859C104.601 96.2972 104.199 95.3757 103.405 94.917C102.606 94.4624 101.607 94.5975 100.947 95.2323C100.869 95.3101 92.9446 102.834 73.72 102.834C54.4955 102.834 46.5665 95.3102 46.4928 95.2364C46.0996 94.8474 45.5754 94.6426 45.0511 94.6426C44.7071 94.6426 44.359 94.7286 44.0436 94.9047C43.2409 95.3634 42.8395 96.2931 43.0648 97.1859Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1467 70.0693C54.8014 70.0693 59.3856 63.6515 59.3856 55.7348C59.3856 47.8181 54.8014 41.4004 49.1467 41.4004C43.4919 41.4004 38.9078 47.8181 38.9078 55.7348C38.9078 63.6515 43.4919 70.0693 49.1467 70.0693Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2933 70.0693C103.948 70.0693 108.532 63.6515 108.532 55.7348C108.532 47.8181 103.948 41.4004 98.2933 41.4004C92.6385 41.4004 88.0544 47.8181 88.0544 55.7348C88.0544 63.6515 92.6385 70.0693 98.2933 70.0693Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.4b72c1681baaf8f5a12ce5b2f68e7308.svg";
export { ForwardRef as ReactComponent };